import { CustomAxiosRequestConfig } from "../../../interceptors/axios/custom-axios";
import { BaseApi } from "../../../services/base-api";
import { PeafOptionsPayload, DownloadPeafOptionsPayload, ProfileView, subscriptionPaylod, SubscriptionViewPayload, DownloadTrackingViewPayload } from "../model/model";
import { ENDPOINTS } from "./endpoint";



export const SubscriptionEmailData = async (
    params: subscriptionPaylod,
):Promise<any> => {
    try {
        const response = await BaseApi.baseApiCon.post(ENDPOINTS.subscriptionEmail, params,{ requiresCSRF: true } as CustomAxiosRequestConfig);
        return response.data?.data ?? response.data;

    } catch (error: any) {
        throw new Error(error?.response?.data?.errorMessage|| error?.response?.data?.errorDescription);
    }
};

export const SaveProfileData = async (
    params: ProfileView,
): Promise<any> => {
    try {
        const response = await BaseApi.baseApiCon.post(ENDPOINTS.changeProfile, params,{ requiresCSRF: true } as CustomAxiosRequestConfig);
        return response.data?.data ?? response.data;

    } catch (error: any) {
        throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.errorDescription);
    }
};



export const GeneratePeafOptions = async (
    params: PeafOptionsPayload,
): Promise<any> => {
    try {
        const response = await BaseApi.baseApiCon.post(
            ENDPOINTS.peafOptions,
            params ,{ requiresCSRF: true } as CustomAxiosRequestConfig       );
        return response.data?.data;
    } catch (error: any) {
        const msg =  error?.response?.data?.errorMessage || error?.response?.data?.errorDescription;
        throw new Error(msg);
    }
};

export const DownloadPeafOptions = async (
    params: DownloadPeafOptionsPayload,
): Promise<any> => {
    try {
        const config: any = params.downloadFiles ? {
            requiresCSRF: true,
            responseType: 'blob',
            timeout: 0,
        } : {
            requiresCSRF: true
        };
        
        const response = await BaseApi.baseApiCon.post(
            ENDPOINTS.downloadPeafOptions,
            params,
            config as CustomAxiosRequestConfig
        );
        
        return params.downloadFiles ? response.data : (response.data?.data ?? response.data);
    } catch (error: any) {
        const msg =  error?.response?.data?.errorMessage || error?.response?.data?.errorDescription;
        throw new Error(msg);
    }
};

export const GetSubscriptionView = async (
    params: SubscriptionViewPayload,
    pageNo: number,
    pageSize: number
): Promise<any> => {
    try {
        const response = await BaseApi.baseApiCon.post(
            `${ENDPOINTS.subscriptionView}?pageNo=${pageNo}&pageSize=${pageSize}`,
            params
        );
        return response.data?.data ;
    } catch (error: any) {
        const msg =  error?.response?.data?.errorMessage || error?.response?.data?.errorDescription;
        throw new Error(msg);
    }
};

export const GetDownloadTrackingView = async (
    params: DownloadTrackingViewPayload,
): Promise<any> => {
    try {
        const response = await BaseApi.baseApiCon.post(
            `${ENDPOINTS.downloadTrackingView}`,
            params
        );
        return response.data?.data ?? response.data;
    } catch (error: any) {
        const msg = error?.response?.data?.errorMessage || error?.response?.data?.errorDescription;
        throw new Error(msg);
    }
};

export const GetPrimusEliteOptionsMenu = async (
    params: { customerNumber: number },
): Promise<any> => {
    try {
        const response = await BaseApi.baseApiCon.post(
            `${ENDPOINTS.primusEliteOptionsMenu}`,
            params
        );
        return response?.data?.data ?? response?.data;
    } catch (error: any) {
        const msg = error?.response?.data?.errorMessage || error?.response?.data?.errorDescription;
        throw new Error(msg);
    }
};
